import { AnalyticsRouter } from "./analytics-router";

const analytics = new AnalyticsRouter();
export default analytics;
